import {getRequest} from '../fetchWrapper';

/**
 * Récupération de la liste des réseaux.
 *
 * @param string token Jeton d'authentification.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const getNetworkList = (token) => {
    const url = `/api-v1/network/list`
    return getRequest(url, token)
}